import React from 'react';
import EmailVerification from '../components/EmailVerification';

const EmailVerificationPage: React.FC = () => {
  return <EmailVerification />;
};

export default EmailVerificationPage; 